import { COU_changeTimeFormat, COU_formatDateToStr } from '@/utils/co_util'
import MallGroupApi from "@/api/zfb/mall_group"

// 获取授权店铺列表
function GetMallList(GroupId) {
  return MallGroupApi.GetMallListByGroupId(1, 100, GroupId)
}

// 时间格式转换 Thu Jul 01 2021 11:10:42 GMT+0800 (中国标准时间)转换为 2021-07-01 11:10:42
function timeFormatHandler(timeSpace) {
  const orderInfoStartTime = COU_changeTimeFormat(timeSpace[0]._d)
  const orderInfoEndTime = COU_changeTimeFormat(timeSpace[1]._d)
  return { orderInfoStartTime, orderInfoEndTime }
}

function checkTimeShow(spaceTimeStamp) {
  // 获取当天的24小时的前一秒
  const todayYear = (new Date()).getFullYear()
  const todayMonth = (new Date()).getMonth()
  const todayDay = (new Date()).getDate()
  // 今天凌晨0点整的时间戳
  const todayStamp = (new Date(todayYear, todayMonth, todayDay, '00','00','00')).getTime()
  let startTime = new Date().getTime()
  let endTime = (new Date(todayYear, todayMonth, todayDay, '23','59','59')).getTime()
  startTime = todayStamp - spaceTimeStamp
  startTime = COU_formatDateToStr(startTime)
  endTime = COU_formatDateToStr(endTime)
  return { startTime, endTime }
}

// 快捷时间按钮和时间框双向绑定
function radioButtonVmodel(timeSpace) {
  let currentStatus = 'DIY'
  let { orderInfoStartTime, orderInfoEndTime } = timeFormatHandler(timeSpace)
  const todayYear = (new Date()).getFullYear()
  const todayMonth = (new Date()).getMonth()
  const todayDay = (new Date()).getDate()
  const endTime = COU_formatDateToStr((new Date(todayYear, todayMonth, todayDay, '23','59','59')))
  if (endTime != orderInfoEndTime) return currentStatus
  const todayStamp = (new Date(todayYear, todayMonth, todayDay, '00','00','00')).getTime()
  orderInfoStartTime = new Date(orderInfoStartTime).getTime()
  dataTimeList.map(item => {
    if (orderInfoStartTime == todayStamp - item.timeStamp) currentStatus = item.timeStamp
  })
  return currentStatus
}

const dataTimeList = [
  { timeName: '今天', timeStamp: 0 },
  { timeName: '昨天', timeStamp: 24*60*60*1000 },
  { timeName: '近3天', timeStamp: 24*60*60*1000*2 },
  { timeName: '近7天', timeStamp: 24*60*60*1000*6 },
  { timeName: '近15天', timeStamp: 24*60*60*1000*14 },
  { timeName: '近30天', timeStamp: 24*60*60*1000*29 },
  { timeName: '近90天', timeStamp: 24*60*60*1000*89 }
]

function GetMyExportConfig () {
  return [
    { key: 'mallName', name: '店铺名称', isCheck: true },
    { key: 'orderId', name: '订单编号', isCheck: true },
    { key: 'orderStatus', name: '订单状态', isCheck: true },
    { key: 'afterStatus', name: '售后状态', isCheck: true },
    { key: 'goodsId', name: '商品编号', isCheck: true },
    { key: 'goodsCount', name: '商品数量', isCheck: true },
    { key: 'goodsTitle', name: '商品标题', isCheck: true },
    { key: 'goodsTotalPrice', name: '商品总额', isCheck: true },
    // { key: 'platformCostAmount', name: '平台补贴', isCheck: true },
    { key: 'payAmount', name: '实付金额', isCheck: true },
    { key: 'cost', name: '拍单金额', isCheck: true },
    { key: 'profit', name: '订单利润', isCheck: true },
    { key: 'purchasedOrderId', name: '拍单订单号', isCheck: true },
    { key: 'purchasedAccount', name: '拍单账号', isCheck: true },
    { key: 'purchasedTime', name: '拍单时间', isCheck: true },
    { key: 'orderCreateTime', name: '下单时间', isCheck: true }
  ]
}

export default { dataTimeList, timeFormatHandler, checkTimeShow, radioButtonVmodel, GetMyExportConfig, GetMallList }